import { FieldState } from 'src/Types';
import { useLocalization, useSelectedOrdersRows } from 'src/Hooks';
import { useSelector } from 'react-redux';
import { globalSelectors } from 'src/Redux/Global/selectors';
import { useMemo } from 'react';
import { localizationUtils } from 'src/Utils/localizationUtils';
import { orderUtils } from '@/Utils/models/Order';

export const useDeliveryNoteTooltipMessage = (): FieldState => {
  const {
    models: {
      OrderTableRow: { DeliveryNoteNumber, parts, CommonErrors },
    },
  } = useLocalization();

  const { orderRows, isPurchasesPage } = useSelectedOrdersRows();
  const localization = useSelector(globalSelectors.localization);

  return useMemo(() => {
    const result = orderRows.reduce(
      (res, current) => {
        if (current.deliveryNoteNumberCreatedTime) {
          res.withDeliveryNoteNumbers.add(current.deliveryNoteNumber ?? '');
        }
        if (orderUtils.isOrderIsAmazonPending(current)) {
          res.amazonInProcessOrders.add(current.userOrderId.toString());
        }
        return res;
      },
      {
        withDeliveryNoteNumbers: new Set<string>(),
        amazonInProcessOrders: new Set<string>(),
      },
    );

    const withDeliveryNoteNumbers = [...result.withDeliveryNoteNumbers];
    const amazonInProcessOrders = [...result.amazonInProcessOrders];

    let disabledDocumentMessage: string | undefined;
    const isIconDisabled = Boolean(withDeliveryNoteNumbers.length || amazonInProcessOrders.length);

    if (withDeliveryNoteNumbers.length) {
      disabledDocumentMessage = localizationUtils.insertTranslatedParamsToString(
        DeliveryNoteNumber.DisableHeaderDocumentMessage,
        [withDeliveryNoteNumbers.join(', '), withDeliveryNoteNumbers.length],
        parts,
        localization,
      );
    } else if (amazonInProcessOrders.length) {
      disabledDocumentMessage = CommonErrors.AmazonOrderPending.DisableHeaderDocumentMessage;
    } // if

    return {
      value: '',
      isDocumentIconDisabled: isIconDisabled || isPurchasesPage,
      disabledDocumentMessage,
    };
  }, [localization, orderRows, isPurchasesPage]);
};
